(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchasePresentItemLotDialogController', PurchasePresentItemLotDialogController);

    PurchasePresentItemLotDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PurchasePresentItemLot', 'PurchasePresentItem'];

    function PurchasePresentItemLotDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PurchasePresentItemLot, PurchasePresentItem) {
        var vm = this;
        vm.purchasePresentItemLot = entity;
        vm.purchasepresentitems = PurchasePresentItem.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:purchasePresentItemLotUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.purchasePresentItemLot.id !== null) {
                PurchasePresentItemLot.update(vm.purchasePresentItemLot, onSaveSuccess, onSaveError);
            } else {
                PurchasePresentItemLot.save(vm.purchasePresentItemLot, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
